import { isMyDrafts } from '@sketch/utils'

import { userIsEditorOrAdmin } from '../../../workspace/utils'
import type { ProjectArchivedDropdownProps } from './ProjectArchivedDropdown'

export const checkCommonPermissionChecks = (
  props: ProjectArchivedDropdownProps
) => {
  const { workspace, project } = props
  const showEditActions = userIsEditorOrAdmin(workspace) && !isMyDrafts(project)
  const showLeaveAction = project.userCanLeave
  const showDivider = showEditActions || showLeaveAction

  return { showEditActions, showLeaveAction, showDivider }
}
